import type { GTMEventReturnType } from '../GTM.types';
import GTMBaseModel from '../GTMBaseModel';

export default class GTMDetailOpenCancellationPolicyInfoButtonClickModel extends GTMBaseModel {
    public static parseToGTMData(): GTMEventReturnType {
        return {
            ...GTMBaseModel.getBaseData(),
            ga4_property: 'cro_event',
            ga4_event_name: 'detail_open_cancellation_policy_info_button_click'
        };
    }
}
